var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLitterAddLitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_add_litter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_add"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.45,
    cy: 301.47,
    r: 297.94,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,242H352.14V157.36a55.8,55.8,0,0,0-55.64-55.65h0a55.81,55.81,0,0,0-55.64,55.65V242H161.24a55.8,55.8,0,0,0-55.64,55.64h0a55.81,55.81,0,0,0,55.64,55.64h79.62v84.69a55.81,55.81,0,0,0,55.64,55.64h0a55.8,55.8,0,0,0,55.64-55.64V353.23H441.8a55.81,55.81,0,0,0,55.64-55.64h0A55.8,55.8,0,0,0,441.8,242Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterAddLitter);
export default __webpack_public_path__ + "static/media/litter_add_litter.66022661afeb8923a5f345c793310f58.svg";
export { ForwardRef as ReactComponent };